import { render, staticRenderFns } from "./CongressData.vue?vue&type=template&id=5402718f&scoped=true"
import script from "./CongressData.vue?vue&type=script&lang=js"
export * from "./CongressData.vue?vue&type=script&lang=js"
import style0 from "./CongressData.vue?vue&type=style&index=0&id=5402718f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5402718f",
  null
  
)

export default component.exports